import { APICallV3Post } from 'reactApp/api/APICall';

export class PushResubscribeAPICall extends APICallV3Post {
    _method = 'push/resubscribe';
}
